module.exports = __webpack_public_path__ + "img/Infografis_EN_11.56119e1e.jpg";